import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerDenuncia'; 
import Denuncia from './CanalDenuncia';

const About = () => {
    return (
      <div>
        <Header />
        <Denuncia />
        <VLibras />
      </div>
    );
  };
  
  export default About;
  